import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureStoreStateKey } from 'src/controls/store-keys.enum';
import { entityAdapter } from './feature.adapters';
import { AuthFeatureState } from './feature.state';

const EntityAdapterSelector = entityAdapter.getSelectors();

const FeatureSelector = createFeatureSelector<AuthFeatureState>(FeatureStoreStateKey.AUTH);
export const userAccountDetails = createSelector(FeatureSelector, (state) => state.currentUser);
export const TokenSelector = createSelector(FeatureSelector, (state) => state.tokens);

export const allowEditJournal = createSelector(userAccountDetails, (state) => {
	let allowEdit: boolean;
	if (state.name == 'webtory') {
		allowEdit = true;
	} else {
		allowEdit = false;
	}

	return allowEdit;
});

export const isLoading = createSelector(FeatureSelector, (state) => state.tokens.isLoading);
export const currentSubdomain = createSelector(FeatureSelector, (state) => state.tokens.currentSubdomain);
export const onLinking = createSelector(TokenSelector, (state) => state.onLinking);

export const l7_token = createSelector(TokenSelector, (state) => state.l7);

export const userToken = createSelector(FeatureSelector, (state) => (state.tokens.loginResp[0].token! = undefined ? state.tokens.loginResp[0].token : undefined));

export const socialAccount = createSelector(userAccountDetails, (state) => {
	let listedAccount = [...state.linkAccount];

	let providerSocialAccount = listedAccount.filter((item) => {
		if (item.provider == 'google') {
			return item;
		} else if (item.provider == 'facebook') {
			return item;
		}
	});

	return providerSocialAccount;
});
